/**
 * Simple DOM watcher for lazy-loaded themes
 * Watches for #fpf_totals element and triggers callback when available
 */
export default class TotalsElementWatcher {
	#observer;
	#callback;

	constructor(callback) {
		this.#callback = callback;
	}

	/**
	 * Start watching for DOM structure changes.
	 */
	startWatching() {
		this.#observer = new MutationObserver((mutationsList) => {
			for (const mutation of mutationsList) {
				if (
					mutation.type !== 'childList' ||
					!mutation.addedNodes.length
				)
					continue;

				for (const node of mutation.addedNodes) {
					if (node.nodeType !== Node.ELEMENT_NODE) continue;

					if (
						node.id === 'fpf_totals' ||
						node.querySelector?.('#fpf_totals')
					) {
						this.stopWatching();
						this.#callback();
						return;
					}
				}
			}
		});

		// Yeah, document.body is a bit wide target, but i couldn't find a better one, that would be consistent.
		// this is a rare case anyways.
		this.#observer.observe(document.body, {
			childList: true,
			subtree: true,
		});
	}

	stopWatching() {
		if (this.#observer) {
			this.#observer.disconnect();
		}
	}
}
